import { useLocation, useNavigate, useParams } from 'react-router-dom';

import { createReport, readReportPrompts } from '@api/reports';
import { Breadcrumbs, Layout } from '@utilities';

import Builder from '../../components/Builder';
import Page from '../../layouts/Page';

const CreateReport = () => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { report: documentId } = useParams();

  return (
    <Page>
      <Layout.Column>
        <Breadcrumbs />
        <Builder
          create={createReport}
          documentId={documentId}
          onSubmit={({ reportId }) => navigate(`/dashboard/report/${reportId}`)}
          read={() => readReportPrompts({ documentId, search, transform: false })}
          type="Report"
        />
      </Layout.Column>
    </Page>
  );
};

export default CreateReport;
